import {Colors, Container, Text} from "bounce-ui/backoffice";
import React from "react";
import {IPlanMatrix} from "../../../../../../../../declerations/server/payment_plan_models";
import {DownPaymentSchedule} from "./DownPaymentSchedule";
import {StandardPaymentSchedule} from "./StandardPaymentSchedule";
import {HardshipPaymentSchedule} from "./HardshipPaymentSchedule";
import {StyledCard} from "../Components";
import {PlanType} from "../utils";

export interface IPaymentScheduleComponents {
  selectedPlan: IPlanMatrix;
  setSelectedPlan: (planMatrix: IPlanMatrix) => void;
  resetSelectedPlan: boolean;
  handleNext: () => void;
  isHardship?: boolean;
  isPreview: boolean;
}

interface IPaymentSchedule {
  selectedPlan: IPlanMatrix;
  setSelectedPlan: (planMatrix: IPlanMatrix) => void;
  handleNext: () => void;
  resetSelectedPlan: boolean;
  isPreview: boolean;
}

export const PaymentSchedule = ({
  selectedPlan,
  setSelectedPlan,
  handleNext,
  resetSelectedPlan,
  isPreview,
}: IPaymentSchedule) => {
  return (
    <StyledCard>
      <Container fullWidth sx={{alignItems: "start", gap: "16px"}}>
        <Text variant={"inter600"} size={14} sx={{textTransform: "uppercase", color: Colors.grey._700}}>
          Payment schedule
        </Text>
        {selectedPlan.plan_type === PlanType.MATRIX_NORMAL && (
          <StandardPaymentSchedule
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
            handleNext={handleNext}
            isPreview={isPreview}
          />
        )}
        {selectedPlan.plan_type === PlanType.MATRIX_DOWN_PAYMENT && (
          <DownPaymentSchedule
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
            resetSelectedPlan={resetSelectedPlan}
            handleNext={handleNext}
            isPreview={isPreview}
          />
        )}
        {selectedPlan.plan_type === PlanType.MATRIX_HARDSHIP &&
          selectedPlan.first_plan_details.number_of_installments === 1 && (
            <DownPaymentSchedule
              selectedPlan={selectedPlan}
              setSelectedPlan={setSelectedPlan}
              resetSelectedPlan={resetSelectedPlan}
              handleNext={handleNext}
              isHardship
              isPreview={isPreview}
            />
          )}
        {selectedPlan.plan_type === PlanType.MATRIX_HARDSHIP &&
          selectedPlan.first_plan_details.number_of_installments > 1 && (
            <HardshipPaymentSchedule
              selectedPlan={selectedPlan}
              setSelectedPlan={setSelectedPlan}
              resetSelectedPlan={resetSelectedPlan}
              handleNext={handleNext}
              isPreview={isPreview}
            />
          )}
      </Container>
    </StyledCard>
  );
};
